module.exports = __webpack_public_path__ + "img/MediumIcon.b745ba57.svg";